/** [配送方式] 與 component 對照表 */
export const componentLut = {
  1: 'recipient-info',
  2: 'store-info',
};
